// extracted by mini-css-extract-plugin
module.exports = {"LogosList":"styles_LogosList__P57fQ"};